// Constructores de modelos 3D por tipo de pieza. Una familia por archivo.
import { buildUno } from './uno.js';
import { buildNano } from './nano.js';
import { buildMega } from './mega.js';
import { buildProMini } from './promini.js';
import { buildAttiny85 } from './attiny85.js';
import { buildUsbSerial } from './usbserial.js';
import { buildPico } from './pico.js';
import { buildBreadboard } from './breadboard.js';
import { MODELS as basic } from './basic.js';
import { MODELS as lcd } from './lcd.js';
import { MODELS as servo } from './servo.js';
import { MODELS as displays } from './displays.js';
import { MODELS as sensors } from './sensors.js';
import { MODELS as inputs } from './inputs.js';
import { MODELS as actuators } from './actuators.js';
import { MODELS as tools } from './tools.js';
import { MODELS as comms } from './comms.js';
import { MODELS as tft } from './tft.js';
import { MODELS as extras } from './extras.js';

export const MODELS = {
  'arduino-uno': buildUno,
  'arduino-nano': buildNano,
  'arduino-mega': buildMega,
  'arduino-pro-mini': buildProMini,
  attiny85: buildAttiny85,
  'usb-serial': buildUsbSerial,
  'pi-pico': buildPico,
  breadboard: buildBreadboard,
  ...basic,
  ...lcd,
  ...servo,
  ...displays,
  ...sensors,
  ...inputs,
  ...actuators,
  ...tools,
  ...comms,
  ...tft,
  ...extras,
};
